import React from "react";
import { Container } from "react-bootstrap";

function Terms() {
  return (
    <Container className="mt-5">
      <h1 className="mb-4 text-center">Terms of Service – Pic-Loud</h1>
      <p><strong>Effective Date:</strong> June 26, 2025</p>

      <h4 className="mt-4">1. Overview</h4>
      <p>
        Pic-Loud allows users to upload and share photos using facial recognition search technology.
        The Service may include features such as QR code generation, social media sharing, and image management tools.
      </p>

      <h4 className="mt-4">2. User Responsibilities</h4>
      <p>
        By using Pic-Loud, you agree to:
        <ul>
          <li>Provide accurate and lawful content.</li>
          <li>Only upload images you have the right to share.</li>
          <li>Not use the Service for any unlawful or abusive purpose.</li>
          <li>Respect the privacy and rights of others featured in photos.</li>
        </ul>
      </p>

      <h4 className="mt-4">3. Privacy & Data Use</h4>
      <p>
        We collect and store personal data only to operate and improve the Service.
        Your uploaded images may be temporarily processed using AI face recognition models for indexing and search purposes.
        We will never sell or misuse your data. For more details, please refer to our Privacy Policy.
      </p>

      <h4 className="mt-4">4. Content Ownership</h4>
      <p>
        You retain full ownership of the images you upload. By uploading, you grant Pic-Loud a limited,
        non-exclusive license to process and display your content solely for the purpose of providing the Service.
      </p>

      <h4 className="mt-4">5. AI Recognition Disclaimer</h4>
      <p>
        Our face recognition is provided as a tool for convenience and is not guaranteed to be 100% accurate.
        Pic-Loud is not liable for misidentification or failure to recognize individuals in photos.
      </p>

      <h4 className="mt-4">6. Availability & Downtime</h4>
      <p>
        We strive to provide reliable service, but availability is not guaranteed.
        We may suspend or terminate the Service at any time, with or without notice, for maintenance, upgrades, or legal reasons.
      </p>

      <h4 className="mt-4">7. Account Suspension or Termination</h4>
      <p>
        We reserve the right to suspend or terminate access to the Service for any reason,
        including violations of these Terms, without prior notice or liability.
      </p>

      <h4 className="mt-4">8. Modifications to Terms</h4>
      <p>
        We may update these Terms at any time. Changes will be effective upon posting.
        Continued use of the Service after changes means you accept the updated Terms.
      </p>

      <h4 className="mt-4">9. Limitation of Liability</h4>
      <p>
        To the maximum extent permitted by law, Pic-Loud is not liable for any indirect, incidental,
        or consequential damages arising from your use of the Service.
      </p>

      <h4 className="mt-4">10. Governing Law</h4>
      <p>
        These Terms are governed by the laws of the State of Israel.
        Any legal disputes must be resolved in the courts of that jurisdiction.
      </p>

      <h4 className="mt-4">11. Contact Us</h4>
      <p>
        If you have questions or concerns about these Terms, please contact us at:<br />
        📧 <strong>Email:</strong> support@pic-loud.com<br />
        🌍 <strong>Website:</strong> <a href="http://www.pic-loud.com" target="_blank" rel="noopener noreferrer">www.pic-loud.com</a>
      </p>
    </Container>
  );
}

export default Terms;
